import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLocations = (locations) => {
  return {
    type: actionTypes.SET_LOCATIONS,
    payload: locations
  }
}
